function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 22657",
  d: "M11.75 0A11.75 11.75 0 0 1 23.5 11.75c0 6.489-11.75 15.75-11.75 15.75S0 18.239 0 11.75A11.75 11.75 0 0 1 11.75 0z",
  fill: "#d83f3f"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Union 24",
  d: "M10.5 17.967c0-.65.386-1.178.861-1.178s.861.529.861 1.178-.387 1.178-.861 1.178-.861-.528-.861-1.178zm.211-3.8v-5.96a.733.733 0 0 1 .756-.707.733.733 0 0 1 .756.707v5.964a.732.732 0 0 1-.756.707.732.732 0 0 1-.756-.707z",
  fill: "#fff",
  stroke: "#fff"
});

function SvgStepperError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.5,
    height: 27.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperError);
export default __webpack_public_path__ + "static/media/stepper-error.9fef30e9.svg";
export { ForwardRef as ReactComponent };